import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo'
    },
    {
        title:Util.L('SKU'),
        key:'sku'
    },{
        title:Util.L('ProductName'),
        key:'productName'
    },{
        title:Util.L('Qty'),
        width:100,
        slot: 'orderQty',
        
    },{
        title:Util.L('ProductPrice'),
        width:100,
        align:'right',
        key:'productPrice',
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.productPrice));
        }
    },{
        title:Util.L('Price'),
        width:100,
        slot: 'price',
        
    },{
        title:Util.L('VATPercent'),
        width:100,
        slot: 'vatPercent',
        
    }
    ,{
        title:Util.L('Action'),
        width:80,
        slot: 'action',
    }]